// extracted by mini-css-extract-plugin
export var buttons = "_aa-0";
export var buttonsActive = "_aa-h";
export var cancelConfirm = "_aa-1";
export var closeButton = "_aa-2";
export var column = "_aa-3";
export var container = "_aa-4";
export var detailHeader = "_aa-6";
export var detailTitle = "_aa-7";
export var detailsContent = "_aa-5";
export var header = "_aa-8";
export var headerWithClose = "_aa-9";
export var icon = "_aa-a";
export var infoIcon = "_aa-c";
export var informationContainer = "_aa-b";
export var sideDrawer = "_aa-d";
export var sideDrawerOpen = "_aa-e";
export var stickyFooter = "_aa-f";
export var typeOption = "_aa-g";